import { translateText } from "../../../../helpers/LanguageHelper";
import React, { useEffect, useRef, useState } from 'react';
import MegaMenu from './MegaMenu';
import SearchHeader from './SearchHeader';
import TopHeader from './TopHeader';
import LanguageSelector from './LanguageSelector';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getLanguageCodeFromSession } from '../../../../helpers/CommonHelper';






const Navbar = () => {
    const [showWhatsAppMenu, setShowWhatsAppMenu] = useState(false);
    const whatsAppMenuRef = useRef(null);
    const loginUserDataJson = useSelector(state => state.userReducer.user);
    const totalCartItems = useSelector(state => state.cartReducer.totalCartItems);
    const loginUser = JSON.parse(loginUserDataJson ?? "{}");
    const langCode = getLanguageCodeFromSession();
    const accountUrl = loginUser?.UserID > 0 ? `/${langCode}/update-profile` : `/${langCode}/login`;
    const whatsappUrl = "https://wa.me/916380413953?text=" + encodeURIComponent("Hello, I need help with my UKL Butter order");
 
    const handleScroll = () => {
      let number = window.pageXOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      if (number >= 300) {
        if (window.innerWidth < 581) document.getElementById("stickyHeader").classList.remove("sticky");
        else document.getElementById("stickyHeader").classList.add("sticky");
      } else document.getElementById("stickyHeader").classList.remove("sticky");
    };
  
    useEffect(() => {
      window.addEventListener("scroll", handleScroll);

      const closeWhatsAppMenu = (event) => {
        if (whatsAppMenuRef.current && !whatsAppMenuRef.current.contains(event.target)) {
          setShowWhatsAppMenu(false);
        }
      };
      document.addEventListener("mousedown", closeWhatsAppMenu);
  
      return () => {
        window.removeEventListener("scroll", handleScroll);
        document.removeEventListener("mousedown", closeWhatsAppMenu);
      };
    }, []);

    return (
        <>


          

            <header id="stickyHeader">
                <LanguageSelector />
                <nav className="mobile-fix-option ukl-mobile-nav" aria-label={translateText("Mobile navigation")}>
                    <Link to={`/${langCode}/`} className="ukl-mobile-nav__item">
                        <i className="fa fa-home" /><span>{translateText("Home")}</span>
                    </Link>
                    <Link to={`/${langCode}/orders-history`} className="ukl-mobile-nav__item">
                        <i className="fa fa-list-alt" /><span>{translateText("Orders")}</span>
                    </Link>
                    <div className="ukl-mobile-nav__support-wrap" ref={whatsAppMenuRef}>
                        {showWhatsAppMenu && (
                            <div className="ukl-mobile-whatsapp-menu" role="menu">
                                <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" role="menuitem" onClick={() => setShowWhatsAppMenu(false)}>
                                    <i className="fa fa-comments" />
                                    <span><strong>{translateText("Chat with us")}</strong><small>{translateText("Questions & support")}</small></span>
                                </a>
                                <Link to={`/${langCode}/whatsapp-order`} role="menuitem" onClick={() => setShowWhatsAppMenu(false)}>
                                    <i className="fa fa-shopping-bag" />
                                    <span><strong>{translateText("WhatsApp Order")}</strong><small>{translateText("Choose products")}</small></span>
                                </Link>
                            </div>
                        )}
                        <button
                            type="button"
                            className="ukl-mobile-nav__item ukl-mobile-nav__support"
                            onClick={() => setShowWhatsAppMenu(current => !current)}
                            aria-expanded={showWhatsAppMenu}
                            aria-haspopup="menu"
                        >
                            <span className="ukl-mobile-nav__support-icon"><i className="fa fa-whatsapp" /></span><span>{translateText("WhatsApp")}</span>
                        </button>
                    </div>
                    <Link to={`/${langCode}/checkout`} className="ukl-mobile-nav__item" aria-label={translateText(`Checkout, ${totalCartItems ?? 0} items in cart`)}>
                        <span className="ukl-mobile-nav__cart-icon">
                            <i className="fa fa-shopping-cart" />
                            {(totalCartItems ?? 0) > 0 && (
                                <span className="ukl-mobile-nav__cart-count">{translateText(totalCartItems > 99 ? "99+" : totalCartItems)}</span>
                            )}
                        </span>
                        <span>{translateText("Checkout")}</span>
                    </Link>
                    <Link to={accountUrl} className="ukl-mobile-nav__item">
                        <i className="fa fa-user" /><span>{translateText("Account")}</span>
                    </Link>
                </nav>
                
                <div className="layout-header2">
                <SearchHeader />
                  
                </div>
                <div className="category-header-2">
                <MegaMenu/>
                </div>
            </header>


        </>
    );

}


export default Navbar;
